import { isExternalPage, shouldIncludeSeoMetadata } from './cms';
function formatDuration(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const secs = Math.floor(seconds % 60);
  let duration = 'PT';
  if (hours > 0) {
    duration += `${hours}H`;
  }
  if (minutes > 0) {
    duration += `${minutes}M`;
  }
  if (secs > 0 || duration === 'PT') {
    duration += `${secs}S`;
  }
  return duration;
}
export function injectVideoJsonLd(embedId, video) {
  if (!isExternalPage() || !shouldIncludeSeoMetadata()) {
    return;
  }
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: video.altText || video.title,
    thumbnailUrl: video.thumbnailUrl,
    uploadDate: video.createdAt,
    contentUrl: video.fileUrl,
    duration: formatDuration(video.duration),
    width: video.width,
    height: video.height
  };
  if (video.seoDescription) {
    jsonLd.description = video.seoDescription;
  }
  if (video.updatedAt) {
    jsonLd.dateModified = video.updatedAt;
  }
  const jsonLdId = `hubspot-video-jsonld-${embedId}`;
  let scriptEl = document.getElementById(jsonLdId);
  if (!scriptEl) {
    scriptEl = document.createElement('script');
    scriptEl.type = 'application/ld+json';
    scriptEl.id = jsonLdId;
    document.head.appendChild(scriptEl);
  }
  scriptEl.textContent = JSON.stringify(jsonLd, null, 2);
}